// src/hooks/usePostData.ts
import { useMutation } from "@tanstack/react-query";
import { message } from "antd"; // Ant Design's message for notifications
 import { AxiosError } from "axios"; 
import apiClient from ".";
import { extractErrorMessage } from "./ErrorHandler";

interface UsePostDataProps<T, V> {
  url: string;
  options?: {
    onSuccess?: (data: T) => void;
    onError?: (error: AxiosError) => void;
    hideMessage?: boolean
  };
}

export const usePostData = <T, V>({ url, options }: UsePostDataProps<T, V>) => {
  return useMutation<T, AxiosError, V>({
    mutationFn: async (data: V) => {
      const response = await apiClient.post<T>(url, data);
      return response.data;
    },
    onError: (error) => {
      const errorMessage = extractErrorMessage(error);
      options.hideMessage && message.error(errorMessage); 
      if (options?.onError) options.onError(error);  
    },
    ...options,
  });
};
